import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'joinArray',
    standalone: true
})
export class JoinArrayPipe implements PipeTransform {

	transform(list: Array<any>, field: string = 'name'): string {
		return list.filter((item: any) => item.hasOwnProperty(field)).map((item: any) => item[field]).join(', ');
	}
}